<template>
    <div id="app">
        <nav class="navbar navigation-border-bottom" role="navigation" aria-label="dropdown navigation">
            <div class="container">
                <router-link :to="{ name: 'landing' }" class="navbar-item logo">
                    <img :src="require('@/assets/img/logo.svg')" alt="Weap.io logo" width="40px" height="28px">
                    <strong>Weap.io</strong>
                </router-link>

                <!-- <div class="navbar-menu">
                    <div class="navbar-end">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                <span><font-awesome-icon icon="user" class="user-icon"/></span>
                                <span class="user-email">alex@weap.io</span>
                            </a>
                            <div class="navbar-dropdown">
                                <a href="/settings" class="navbar-item">
                                    <span><font-awesome-icon icon="cog"/></span>
                                    <span style="padding-left:10px;">Settings</span>
                                </a>
                                <a href="/logout" class="navbar-item">
                                    <span><font-awesome-icon icon="sign-out-alt"/></span>
                                    <span style="padding-left:10px;">Logout</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </nav>
        <div class="container">
            <router-view/>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppFooter from '@/components/Layout/Footer.vue';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    components: {
        AppFooter,
    },

    created() {
        library.add(faCheckCircle);
    },
}
</script>
